import { useContext } from "react";

import styled from "styled-components/macro";

import { FlocknoteAppState } from "Flocknote/state.js";

import FnrIcon from "UI/FnrIcon";
import { colors } from "UI/colors";

import useFamilyRegistrationAdminPermissions, {
  useShouldHideFamRegSettings,
} from "../Shared/useFamilyRegistrationAdminPermissions";

import AdminPanelNavigationBar from "./AdminPanelNavigationBar";

export default function AdminPanelHeader() {
  const shouldHideFamRegSettings = useShouldHideFamRegSettings();
  const [
    {
      composer: { minimized: composerMinimized },
    },
  ] = useContext(FlocknoteAppState);

  const { shouldHideNonNetworkEnabledSettings } =
    useFamilyRegistrationAdminPermissions();

  const leftNavCollapsed =
    window.innerWidth < 1480 || (composerMinimized && window.innerWidth < 1140);

  return (
    <Wrapper>
      <TitleRow
        style={
          leftNavCollapsed
            ? {
                paddingLeft: 128,
              }
            : null
        }
      >
        {!leftNavCollapsed && (
          <FnrIcon far fa-address-book style={{ opacity: 0.6 }} />
        )}
        <Title data-cy="familyRegSetupTitle">{`Family & Visitor Registration Setup`}</Title>
      </TitleRow>

      <AdminPanelNavigationBar
        disabled={
          shouldHideFamRegSettings || shouldHideNonNetworkEnabledSettings
        }
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${colors.fnBorderGray};
  background: ${colors.fnHeaderGray};
  z-index: 310;
  width: 100%;
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;
`;

const TitleRow = styled.div`
  padding: 20px 12px 0 18px;
  font-size: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
`;
const Title = styled.div`
  margin-left: 12px;
`;
